export const tenantConstants = {
  SET_TENANT_SUCCESS: 'SET_TENANT_SUCCESS',
}
